import { useEffect, useState } from "react";

// Surfaces whether/how this device can install Mnandi as an app. Android/Chrome exposes a real
// `beforeinstallprompt` event a page can trigger on demand; iOS Safari has no such API at all
// (a deliberate Apple platform limitation, not something a service worker or JS can work around)
// and always requires the manual Share -> Add to Home Screen gesture, so callers branch on
// `isIOS` rather than assume one code path installs everywhere.
export function useInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [installed, setInstalled] = useState(
    () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true
  );

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

  const promptInstall = async () => {
    if (!deferredPrompt) return null;
    deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    return choice.outcome;
  };

  return { installed, isIOS, canPromptNatively: !!deferredPrompt, promptInstall };
}
